import { Input } from "@headlessui/react";
import clsx from "clsx";
import React from "react";

export default function InputField({
  placeholder,
  errorMsg,
  disabled,
  name,
  id,
  ref,
  className,
  type = "text",
  ...restProps
}) {
  return (
    <Input
      className={({ disabled }) =>
        clsx(
          disabled && "tw-bg-disabled-bg-light tw-text-disabled-text",
          errorMsg && "tw-ring-2 tw-border-none tw-outline-none tw-ring-error-light",
          "tw-border tw-border-boarder-light tw-py-1 tw-px-2 tw-h-9 tw-rounded-md tw-text-text-primary-light",
          "tw-focus:outline-none tw-focus:border-none tw-focus:ring-2 ",
          errorMsg ? " tw-focus:ring-error-light" : " tw-focus:ring-focus",
          className
        )
      }
      placeholder={placeholder}
      disabled={disabled}
      ref={ref}
      {...restProps}
      type={type}
      name={name}
      id={name}
    />
  );
}
